import axios from "axios";
function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}
export const getWeeklyReport = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/lead-report/weekly_report/`,
      getHeaders()
    );
    // return {
    //   data: response.data.data,  // Weekly data
    //   // list: response.data.list,  // Leads data
    // };
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch weekly report"
    );
  }
};
